import * as React from 'react';
import type { SVGProps } from 'react';

const IconMoney = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 64" {...props}>
    <path
      d="M17.406 63.65v-6.092C9.773 56.822 1.47 52.336.668 43.766h7.164c.067 5.758 3.816 10.31 9.574 11.315V34.593l-1.607-.401C9.64 32.45 2.074 28.3 2.074 19.998c0-8.235 6.896-12.386 15.332-12.788V.247h3.147V7.21c7.565.603 14.93 5.088 15.733 13.86h-7.164c-.066-5.826-2.878-10.512-8.57-11.383v18.68l1.942.536c7.499 1.941 15.533 5.423 15.533 14.528 0 9.507-8.101 13.993-17.474 14.26v5.96h-3.147Zm3.816-28.052-.67-.134v19.818c7.232-.201 11.65-3.348 11.65-9.775 0-6.227-4.686-8.302-10.98-9.91ZM7.631 18.19c0 5.825 5.825 8.235 9.775 9.307V9.62c-7.298.402-9.775 4.352-9.775 8.57Z"
      fill="#f0ece5"
    />
  </svg>
);

export default IconMoney;
